import { render, staticRenderFns } from "./FormApplications.vue?vue&type=template&id=16d48909&scoped=true"
import script from "./FormApplications.vue?vue&type=script&lang=js"
export * from "./FormApplications.vue?vue&type=script&lang=js"
import style0 from "./FormApplications.vue?vue&type=style&index=0&id=16d48909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d48909",
  null
  
)

export default component.exports